import React from "react";
import styles from "./ColorCards.module.scss";
import Image from "next/image";
import { colorCardType } from "../../Enum";
import CircularProgress from "@/common/components/CircularProgressBar/index";

const ColorsCard = ({
  icon,
  title,
  description,
  received_points = 0,
  total_points,
  bgColor = "",
}: colorCardType) => {
  return (
    <div className={styles.detailsCard} style={{ background: bgColor }}>
      <div>
        <div className={styles.cardTitle}>
          {icon && <Image src={icon} alt="card-icons" height={24} width={24}/>}
          <h4>{title}</h4>
        </div>
        <div className={styles.cardDescription}>{description}</div>
      </div>
      {total_points && (
        <CircularProgress
          radius={30}
          progress={(received_points / total_points) * 100}
          text={`${received_points}/${total_points}`}
        />
      )}
    </div>
  );
};

export default ColorsCard;
